import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    component_itemsPerPage: {
      [SERVICE_PROVIDERS.SPIREON]: () => 10,
      default: () => 15,
    },
    topAction_bulkDownload: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
